import React from 'react';
import PropTypes from 'prop-types';

import { COLORS } from '../../constants/styles';
import Button from '../Button';
import Icon from '../Icon';

import styles from './index.styl';

function InvitationButton({ onClick, formatMessage }) {
  return (
    <Button color="accent" onClick={onClick} className={styles.button}>
      <Icon
        name="assign-blue"
        size={24}
        style={{ fill: COLORS.blueAccent }}
        className="mr1"
      />
      <span className={styles.buttonText}>
        {formatMessage({ id: 'dialog.common.invitePerson' })}
      </span>
    </Button>
  );
}

InvitationButton.propTypes = {
  onClick: PropTypes.func,
  formatMessage: PropTypes.func,
};

export default InvitationButton;



// WEBPACK FOOTER //
// ./src/components/InvitationBox/InviteButton.jsx